'use strict';

var accentColors = {};

exports.__exports = accentColors;
//# sourceMappingURL=accentColors.cjs.map
